import { GradientButton } from './gradient-button'

export const YellowGradientButton: React.FC<IGradientButton> = (props) => (
  <GradientButton gradient="yellow" {...props} />
)
